import { z } from "zod";

export const MediaSchema = z.object({
    id: z.union([z.string(), z.number()]).transform(val => String(val)),
    key: z.string(),
    filename: z.string(),
    url: z.string().url(),
    cdn_url: z.string().url(),
    mime_type: z.string(),
    size: z.number(),
    formatted_size: z.string(),
    width: z.number().nullable().optional(),
    height: z.number().nullable().optional(),
    is_temporary: z.boolean(),
    collection: z.string(),
    created_at: z.string(),
    metadata: z.record(z.string(), z.unknown()).nullable().optional(),
});

export type Media = z.infer<typeof MediaSchema>;

export const MediaUploadResponseSchema = MediaSchema;

export type MediaUploadResponse = z.infer<typeof MediaUploadResponseSchema>;

export const MediaUploadMultipleResponseSchema = z.array(MediaSchema);

export type MediaUploadMultipleResponse = z.infer<typeof MediaUploadMultipleResponseSchema>;

export const MediaStatsSchema = z.object({
    total_files: z.number(),
    total_size: z.number(),
    formatted_total_size: z.string(),
    temporary_files: z.number(),
    files_by_collection: z.record(z.string(), z.number()),
    top_users_by_storage: z.array(z.object({
        user: z.object({
            id: z.number(),
            name: z.string(),
            email: z.string(),
        }),
        file_count: z.number(),
        total_size: z.number(),
        formatted_size: z.string(),
    })),
});

export type MediaStats = z.infer<typeof MediaStatsSchema>;

export interface MediaListQueryParams {
    user_id?: number;
    collection?: string;
    is_temporary?: boolean;
    from_date?: string; // YYYY-MM-DD
    to_date?: string; // YYYY-MM-DD
    cursor?: string;
    per_page?: number;
}

